// extracted by mini-css-extract-plugin
module.exports = {"FilterTabs":"FilterTabs_FilterTabs__9uyJJ","Active":"FilterTabs_Active__750cZ"};